import React from "react";
import Transaction from "../../old_Components/TransactionHistory/TransactionHistory";
import { Component } from "react";
import constant from "../../constant";
import queryString from "query-string";
import { SubscribedPackageList } from "../../action/SubscriptionManagement";
import { render } from "@testing-library/react";

export default class TransactionHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: undefined,
    };
  }

  componentDidMount() {
    this.SubscriptionLists();
    document.title =  constant.title.TransactionHistory
  }

  SubscriptionLists = () => {
    SubscribedPackageList()
      .then((res) => {
        if (res.status) {
          this.setState({ detail: res.result.list });
        }
      })
      .catch((err) => {
        alert(err);
      });
  };

  render() {
    return (
      <React.Fragment>
        <Transaction details={this.state.detail} />
      </React.Fragment>
    );
  }
}
